import api from '@/api';

import {
    CURRENT_TAB,
    DEFAULT_PARAMETERS_FOR_SOLVING,
    REPORTING_PERIOD,
    ENTRY_PERIOD,
} from '@/components/OilProductionLossOld/lib/constants';

const oilProductionLossModel = {
    state: {
        loading: false,
        versionIsloading: false,
        error: false,
        currentTab: CURRENT_TAB.CALCULATION_SETTINGS,
        solved: false,
        miningVersionsList: null, // список версий для месторождения
        stratumsList: null, // список пластов для месторождения и выбранной версии
        isChartsActive: false,
        isApproximationActive: false,
        isChartActive: false,
        isTableActive: true,
        lossOilProduction: null,
        unsolvedResultParameters: {
            miningVersion: null,
            reportingPeriod: REPORTING_PERIOD[0].value,
            entryPeriod: ENTRY_PERIOD[0].value,
            stratums: null,
        },
        solvedResultParameters: {
            miningVersion: null,
            reportingPeriod: REPORTING_PERIOD[0].value,
            entryPeriod: ENTRY_PERIOD[0].value,
            stratums: null,
        },
    },
    reducers: {
        setLoading(state, payload) {
            return { ...state, loading: payload };
        },
        setVersionLoading(state, payload) {
            return { ...state, versionIsloading: payload };
        },
        setError(state, payload) {
            return { ...state, error: payload };
        },
        setMiningVersionsList(state, payload) {
            return { ...state, miningVersionsList: payload };
        },
        setStratumsList(state, payload) {
            return { ...state, stratumsList: payload };
        },
        setSolvedResultParameters(state, payload) {
            return { ...state, solvedResultParameters: payload };
        },
        setUnsolvedResultParameters(state, payload) {
            return { ...state, unsolvedResultParameters: { ...state.unsolvedResultParameters, ...payload } };
        },
        setChartsActive(state, payload) {
            return { ...state, isChartsActive: payload, isApproximationActive: !payload };
        },
        setApproximationActive(state, payload) {
            return { ...state, isApproximationActive: payload, isChartsActive: !payload };
        },
        setChartActive(state, payload) {
            return { ...state, isChartActive: payload };
        },
        setTableActive(state, payload) {
            return { ...state, isTableActive: payload };
        },
        setLossOilProduction(state, payload) {
            return { ...state, lossOilProduction: payload };
        },
        setCurrentTab(state, payload) {
            return { ...state, currentTab: payload };
        },
        setSolved(state, payload) {
            return { ...state, solved: payload };
        },
    },
    effects: _dispatch => ({
        async fetchMiningVersionsAsync(params) {
            this.setLoading(true);
            this.setVersionLoading(true);
            try {
                const response = await api.oilProductionLoss.fetchMiningVersions(JSON.stringify(params));

                this.setMiningVersionsList(response);
                this.setUnsolvedResultParametersValue({ miningVersion: response[0]?.id });
                this.setLoading(false);
            } catch (error) {
                this.setError(error);
                this.setLoading(false);
            }
            this.setVersionLoading(false);
        },
        async fetchStratumsAsync(params) {
            this.setLoading(true);
            const payload = { body: params };
            try {
                const response = await api.oilProductionLoss.fetchStratums(payload);

                this.setStratumsList(response);
                this.setLoading(false);
            } catch (error) {
                this.setError(error);
                this.setLoading(false);
            }
        },

        async getLossOilProduction(params) {
            this.setLoading(true);

            try {
                const response = await api.oilProductionLoss.fetchLossOilProduction(params);

                this.setLossOilProduction(response);
                this.setLoading(false);
            } catch (e) {
                this.setError(e);
                this.setLoading(false);
            }
        },

        dropStoreToDefault() {
            this.setCurrentTab(CURRENT_TAB.CALCULATION_SETTINGS);
            this.setSolved(false);
            this.setSolvedResultParameters({
                miningVersion: null,
                reportingPeriod: REPORTING_PERIOD[0].value,
                entryPeriod: ENTRY_PERIOD[0].value,
                stratums: null,
            });
            this.setUnsolvedResultParameters({
                miningVersion: null,
                reportingPeriod: REPORTING_PERIOD[0].value,
                entryPeriod: ENTRY_PERIOD[0].value,
                stratums: null,
            });
            this.setStratumsList(null);
            this.setMiningVersionsList(null);
            this.setLossOilProduction(null);
            this.setChartsActive(true);
            this.setTableActive(true);
            this.setChartActive(false);
        },
    }),
};

export default oilProductionLossModel;
